import { providers } from "../../variables"

const controllers = {
    winMarket: 'wm',
    derivMarket: 'dm',
    trackCode: 'track-code',

    rdsMeeting: 'meetings',
    rdsEvent: 'events',
    rdsSelection: 'selections'
}

const winMarket = (controller: string) => {
    return {
        getAll: (eventId: number) => `${controller}/${eventId}`,
        get: (eventId: number, marketUpdateId: number) => `${controller}/${eventId}/${marketUpdateId}`,
        updateSuspendEP: (eventId: number, status: string) => `${controller}/${eventId}/ep/${status}`,
        updateBettingState: (eventId: number, bettingState: string) => `${controller}/${eventId}/bs/${bettingState}`,
        ignorePrices:(eventId: number) => `${controller}/${eventId}/ignore/${providers.betmakers}`
    }
}

const derivMarket = (controller: string) => {
    return {
        getAll: (eventId: number) => `${controller}/${eventId}`,
        get: (eventId: number, marketType: number) => `${controller}/${eventId}/${marketType}`
    }
}

const trackCode = (controller: string) => {
    return {
        getAll: (provider: string) => `${controller}/${provider}`,
        get: (provider: string, trackCodeKey: string) => `${controller}/${provider}/${trackCodeKey}`,
        save: controller,
        upload: (provider: string) => `${controller}/upload/${provider}`,
        delete: (provider: string, trackCodeKey: string) => `${controller}/${provider}/${trackCodeKey}`
    }
}

const rdsMeeting = (controller: string) => {
    return {
        getAll: `${controller}`,
        get: (meetingId: number) => `${controller}/${meetingId}`,
        tracks: 'tracks'
    }
}

const rdsEvent = (controller: string) => {
    return {
        getAll: `${controller}`,
        get: (eventId: number) => `${controller}/${eventId}`,
        eventStatuses: (eventId: number) => `eventstatuses/${eventId}`
    }
}

const rdsSelection = (controller: string) => {
    return {
        getAll: `${controller}`,
        getRunner: (selectionId: number) => `runners/${selectionId}`
    }
}

export const apiUrls = {
    winMarket: winMarket(controllers.winMarket),
    derivMarket: derivMarket(controllers.derivMarket),
    trackCode: trackCode(controllers.trackCode),

    rdsMeeting: rdsMeeting(controllers.rdsMeeting),
    rdsEvents: rdsEvent(controllers.rdsEvent),
    rdsSelections: rdsSelection(controllers.rdsSelection)
}
